export default "__VITE_ASSET__CezrWvX9__"